//User Engagement
import Group428 from '../assets/images/icons/Group428.png';
import Group446 from '../assets/images/icons/Group446.png';
import Group447 from '../assets/images/icons/Group447.png';
import Group450 from '../assets/images/icons/Group450.png';
import Vector7 from '../assets/images/icons/Vector7.png';

import Group468 from '../assets/images/icons/analytics/Group468.svg';
import Group467 from '../assets/images/icons/analytics/Group467.svg';
import Group498 from '../assets/images/icons/analytics/Group498.svg';
import Vector1 from '../assets/images/icons/analytics/Vector1.svg';
import Vector2 from '../assets/images/icons/analytics/Vector2.svg';
import Vector from '../assets/images/icons/analytics/Vector.svg';
import India from '../assets/images/icons/analytics/India.svg';
import Brazil from '../assets/images/icons/analytics/Brazil.svg';
import Japan from '../assets/images/icons/analytics/Japan.svg';
import Southafrica from '../assets/images/icons/analytics/Southafrica.svg';
import Southkorea from '../assets/images/icons/analytics/Southkorea.svg';
import Unitedarabemirates from '../assets/images/icons/analytics/Unitedarabemirates.svg';
import Unitedkingdom1 from '../assets/images/icons/analytics/Unitedkingdom1.svg';
import Unitedkingdom from '../assets/images/icons/analytics/Unitedkingdom.svg';
import Unitedstates from '../assets/images/icons/analytics/Unitedstates.svg';

//UiElements
import Group749 from '../assets/images/icons/analytics/Group749.svg';

//Heat maps
import Group275 from '../assets/images/icons/analytics/Group275.svg';
import Group444 from '../assets/images/icons/analytics/Group444.svg';

// Images Import Here Here

import com10 from '../assets/images/img/com10_new.svg';
import group101Image from '../assets/images/img/Group 101.svg';
import group102Image from '../assets/images/img/Group 102.svg';
import group103Image from '../assets/images/img/Group 103.svg';
import group104Image from '../assets/images/img/Group 104.svg';
import group105Image from '../assets/images/img/Group 105.svg';
import group170Image from '../assets/images/img/Group 170.svg';
import group41Image from '../assets/images/img/Group 41.svg';
import Line9Image from '../assets/images/img/Line 9.svg';
import layer2Image from '../assets/images/img/Layer_2.svg';
import helpImage from '../assets/images/img/help.svg';
import instagram from '../assets/images/img/instagram.svg';
import youtube from '../assets/images/img/youtube.svg';
import linkdin from '../assets/images/img/linkdin.svg';
import discord from '../assets/images/img/discord.svg';
import x from '../assets/images/img/x.svg';
import logo_small from '../assets/images/img/logo-small.png';
import card from '../assets/images/img/card.svg';
import logo from '../assets/images/img/logo.png';
import visual_editor from '../assets/images/img/visual-editor.png';
import XR from '../assets/images/img/XR.svg';
import logoImage from '../assets/images/img/Group 323.svg';
import SearchIcon from '../assets/images/img/Group 99.svg';
import group96Image from '../assets/images/img/Group 96.svg';
import qrCodeImage from '../assets/images/img/qrcode.png';

// New Projects Creation Images///

import areaTracking from '../assets/images/img/Area.jpg';
import bodyTracking from '../assets/images/img/Body.jpg';
import faceTracking from '../assets/images/img/Face.jpg';
import imageTracking from '../assets/images/img/Image.jpg';
import locationTracking from '../assets/images/img/Location.jpg';
import surfaceTracking from '../assets/images/img/Surface.jpg';
import worldTracking from '../assets/images/img/World.jpg';

import handTracking from '../assets/images/img/Hand-Tracking.png';
import torsoTracking from '../assets/images/img/Torso-Tracking.png';
import footTracking from '../assets/images/img/Foot-Tracking.png';
import wristTracking from '../assets/images/img/Wrist-Tracking.png';

// Videos Import Here Here

// import industrial from '../assets/images/video/First-Industrial.mp4';
// import arPhone from '../assets/images/video/First-AR-Phone.mp4';
// import lunar from '../assets/images/video/First-Lunar.mp4';

// import edutech from '../assets/images/video/Edutech.mp4';
// import simulation from '../assets/images/video//Simulation.mp4';
// import prototype from '../assets/images/video/PrototypeDrone.mp4';
// import gamification from '../assets/images/video/gamification.mp4';
// import salesandmarketing from '../assets/images/video/sales-marketing.mp4';

// Icons Import Here Here

import group131Image from '../assets/images/icons/Group 131.svg';
import vector2Image from '../assets/images/icons/Vector2.svg';
import group34Image from '../assets/images/icons/Group 34.svg';
import group24Image from '../assets/images/icons/Vector copy.svg';
import group252Image from '../assets/images/icons/Group 24.svg';
import group25Image from '../assets/images/icons/Group 25.svg';
import group26Image from '../assets/images/icons/Group 26.svg';
import menuIcon from '../assets/images/icons/Group 11.svg';
import group9Image from '../assets/images/icons/Group 9.svg';
import group7Image from '../assets/images/icons/Group 7.svg';
import group8Image from '../assets/images/icons/Group 8.svg';
import group4Image from '../assets/images/icons/Group 4.svg';
import line4Image from '../assets/images/icons/Line 4.svg';
import line5Image from '../assets/images/icons/Line 5.svg';
import line7Image from '../assets/images/icons/Line 7.svg';
import vector6Image from '../assets/images/icons/Vector 6.svg';
import vector8Image from '../assets/images/icons/Vector8.svg';
import vector9Image from '../assets/images/icons/Vector9.svg';
import vector10Image from '../assets/images/icons/Vector10.svg';
import group72Image from '../assets/images/icons/Group72.svg';
import group73Image from '../assets/images/icons/Group73.svg';
import group74Image from '../assets/images/icons/Group74.svg';
import group39Image from '../assets/images/icons/Group39.svg';

import group141Image from '../assets/images/icons/Group 141.svg';
import vector3Image from '../assets/images/icons/Vector 3.svg';
import vectorImage from '../assets/images/icons/Vector.svg';
import vector4Image from '../assets/images/icons/Vector 4.svg';
import Unlockvector5Image from '../assets/images/icons/UnlockVector5.svg';
import group290Image from '../assets/images/icons/Group 290.svg';
import line1Image from '../assets/images/icons/Line 1.svg';
import line2Image from '../assets/images/icons/Line 2.svg';
import line3Image from '../assets/images/icons/Line 3.svg';
import questionImage from '../assets/images/icons/question.svg';

import group32Image from '../assets/images/icons/Group 32.svg';
import group33Image from '../assets/images/icons/Group 33.svg';
import group35Image from '../assets/images/icons/Group 35.svg';

import group10Image from '../assets/images/icons/Group 10.svg';
import group13Image from '../assets/images/icons/Group 13.svg';
import group16Image from '../assets/images/icons/Group 16.svg';
import group14Image from '../assets/images/icons/Group 14.svg';
import group15Image from '../assets/images/icons/Group 15.svg';
import group20Image from '../assets/images/icons/Group 20.svg';
import vector5Image from '../assets/images/icons/Vector 5.svg';
import line6Image from '../assets/images/icons/Line 6.svg';
import group562Image from '../assets/images/icons/Group 562.svg';
import group563Image from '../assets/images/icons/Group 563.svg';
import group564Image from '../assets/images/icons/Group 564.svg';
import group566Image from '../assets/images/icons/Group 566.svg';
import group567Image from '../assets/images/icons/Group 567.svg';
import group569Image from '../assets/images/icons/Group 569.svg';
import group570Image from '../assets/images/icons/Group 570.svg';
import group571Image from '../assets/images/icons/Group 571.svg';
import group572Image from '../assets/images/icons/Group 572.svg';
import Vector44Image from '../assets/images/icons/Vector44.svg';
import Vector45Image from '../assets/images/icons/Vector45.svg';
import group98Image from '../assets/images/icons/Group 98.svg';
import filterImage from '../assets/images/icons/filter.svg';
import LibraryImage from '../assets/images/icons/Library.svg';
import group40Image from '../assets/images/icons/Group40.svg';
import group42Image from '../assets/images/icons/Group42.svg';
import backarrowImage from '../assets/images/icons/BackArrow.svg';
import group598Image from '../assets/images/icons/Group598.svg';

import Layer1Image from '../assets/images/icons/Layer1.svg';
import Layer2Image from '../assets/images/icons/Layer2.svg';
import Layer3Image from '../assets/images/icons/Layer3.svg';
import Layer4Image from '../assets/images/icons/Layer4.svg';
import Layer5Image from '../assets/images/icons/Layer5.svg';
import Layer6Image from '../assets/images/icons/Layer6.svg';
import Layer7Image from '../assets/images/icons/Layer7.svg';
import Layer8Image from '../assets/images/icons/Layer8.svg';
import Layer9Image from '../assets/images/icons/Layer9.svg';
import Layer10Image from '../assets/images/icons/Layer10.svg';
import Layer11Image from '../assets/images/icons/Layer11.svg';
import Layer12Image from '../assets/images/icons/Layer12.svg';
import Layer13Image from '../assets/images/icons/Layer13.svg';

import Element1Image from '../assets/images/icons/Element1.svg';
import Element2Image from '../assets/images/icons/Element2.svg';
import Element3Image from '../assets/images/icons/Element3.svg';
import Element4Image from '../assets/images/icons/Element4.svg';
import Element5Image from '../assets/images/icons/Element5.svg';
import Element6Image from '../assets/images/icons/Element6.svg';
import Element7Image from '../assets/images/icons/Element7.svg';

import Light1Image from '../assets/images/icons/Light1.svg';
import Light2Image from '../assets/images/icons/Light2.svg';
import Light3Image from '../assets/images/icons/Light3.svg';
import ambientlight from '../assets/images/icons/ambientlight.svg';
import arealight from '../assets/images/icons/arealight.svg';

import Help1Image from '../assets/images/icons/Help1.svg';
import Help2Image from '../assets/images/icons/Help2.svg';
import Help3Image from '../assets/images/icons/Help3.svg';
import Help4Image from '../assets/images/icons/Help4.svg';

import group112Image from '../assets/images/icons/Group112.svg';
import group95Image from '../assets/images/icons/Group95.svg';
import vpsZip from '../assets/images/icons/vpszip.svg';

import Emoji1Image from '../assets/images/icons/Emoji1.svg';
import Emoji2Image from '../assets/images/icons/Emoji2.svg';
import Emoji3Image from '../assets/images/icons/Emoji3.svg';
import Emoji4Image from '../assets/images/icons/Emoji4.svg';
import Emoji5Image from '../assets/images/icons/Emoji5.svg';

import group117Image from '../assets/images/icons/Group117.svg';
import group595Image from '../assets/images/icons/Group595.svg';
import threeDots from '../assets/images/icons/three-dots.svg';
import group406Image from '../assets/images/icons/Group406.svg';
import group750Image from '../assets/images/icons/Group750.svg';
import group388Image from '../assets/images/icons/Group388.svg';
import spatialgridLogo from '../assets/images/icons/spatialgrid-logo.png';
import searchImage from '../assets/images/icons/Group 850.png';
import playParticale from '../assets/images/icons/playPartical.svg';
import pausePartical from '../assets/images/icons/pausePartical.svg';
import Light4 from '../assets/images/icons/Light4.svg';
import projectFilter1 from '../assets/images/icons/projectFilter1.svg';
import projectFilter2 from '../assets/images/icons/projectFilter2.svg';
import gaussianSplat from '../assets/images/icons/gaussian-splat.svg';

import HelpCenterLevelIII from '../assets/images/img/helpCenterLevelII.png';
import HelpCenterLevelIII_2 from '../assets/images/img/HelpCenterLevelII_2.png';

import cursorImg from '../assets/images/img/cursor-icon.svg';
import medhaLogo from '../assets/images/img/medha_logo.svg';

import PlayIcon from '../assets/images/icons/playIcon.svg';
import QRIcon from '../assets/images/icons/QRIcon.svg';
//Trending projects of analytics
import perspective from '../assets/images/icons/perspective.svg';
import orthographic from '../assets/images/icons/orthographic.svg';

import analytics1 from '../assets/images/img/Analytics/analytics1.svg';
// import  analytics2 from '../assets/images/img/Analytics/analytics2.svg';
import analytics3 from '../assets/images/img/Analytics/analytics3.svg';
import analytics4 from '../assets/images/img/Analytics/analytics4.svg';
import analytics5 from '../assets/images/img/Analytics/analytics5.svg';
import analytics6 from '../assets/images/img/Analytics/analytics6.svg';
import analytics7 from '../assets/images/img/Analytics/analytics7.svg';

// Rest of the existing code remains the same...
import logoutIcon from '../assets/images/icons/logout.svg';
//add components dropdowns
import icon1 from '../assets/images/img/addcomponent/_icons.svg';
import group306 from '../assets/images/img/addcomponent/Group306.svg';
import group366 from '../assets/images/img/addcomponent/Group366.svg';
import group368 from '../assets/images/img/addcomponent/Group368.svg';
import vectorfile from '../assets/images/img/addcomponent/VectorEventFile.svg';

// New Icons by Naveen
import plusIcon from '../assets/images/icons/plusIcon.svg';
import minusIcon from '../assets/images/icons/minusIcon.svg';
import rightArrowRed from '../assets/images/icons/RightArrowRed.svg';
import googleIcon from '../assets/images/icons/GoogleIcon.svg';
import leftIcon from '../assets/images/icons/LeftIcon.svg';
import downIcon from '../assets/images/icons/DownIcon.svg';
import rightIcon from '../assets/images/icons/RightIcon.svg';
import closeIcon from '../assets/images/icons/closeIcon.svg';
import folderIcon from '../assets/images/icons/FolderIcon.svg';
import eyeIcon from '../assets/images/icons/EyeIcon.svg';
import AudioIcon from '../assets/images/icons/MusicNote.png';

// export const audiocomponent ={
//   AudioIcon,
// }

import waterParticleTexture from '../assets/images/img/waterParticleTexture.jpg';

// import padImg from '../assets/images/img/white_circle.png';

// new Icons for Text module
import horizontolLeft from '../assets/images/icons/horizontal_left.png';
import horizontolCenter from '../assets/images/icons/horizontal_center.png';
import horizontolRight from '../assets/images/icons/horizontal_right.png';

import verticalTop from '../assets/images/icons/vertical_top.png';
import verticalCenter from '../assets/images/icons/vertical_center.png';
import verticalBottom from '../assets/images/icons/vertical_bottom.png';
import text from '../assets/images/icons/text.svg';

// upload Icon
import uploadIcon from '../assets/images/icons/uploadIcon.png';
import uploadIcon2 from '../assets/images/icons/upload_icon.png';
import replayIcon from '../assets/images/icons/replay_icon.png';

// MCP icons ///
import mcpSpeaker from '../assets/images/icons/mcpSpeaker.svg';
import mcpTool from '../assets/images/icons/mcpTool.svg';
import gridImage from '../assets/images/img/gridImage.svg';
import mcpArrow from '../assets/images/icons/mcpArrow.svg';
import mcpScrollView from '../assets/images/icons/mcpScrollView.svg';
import newChat from '../assets/images/icons/newChat.svg';
import mcpHistoryOpen from '../assets/images/icons/mcpHistoryOpen.svg';
import mcpHistoryClose from '../assets/images/icons/mcpHistoryClose.svg';
import historyDeleteWarning from '../assets/images/icons/historyDeleteWarning.svg';

import copy_link from '../assets/images/icons/copy_link.png';
import share_vie_email from '../assets/images/icons/share_vie_email.png';
import embaded_code from '../assets/images/icons/embaded_code.png';
import invite_collaborators from '../assets/images/icons/invite_collaborators.png';
import verticalThreeDots from '../assets/images/icons/vertical-threedots.svg';
//Animation icons
import Ani1 from '../assets/images/icons/Animation/Ani1.svg';
import Ani2 from '../assets/images/icons/Animation/Ani2.svg';
import Ani3 from '../assets/images/icons/Animation/Ani3.svg';
import Ani4 from '../assets/images/icons/Animation/Ani4.svg';
import Ani5 from '../assets/images/icons/Animation/Ani5.svg';
import Ani6 from '../assets/images/icons/Animation/Ani6.svg';
import Ani7 from '../assets/images/icons/Animation/Ani7.svg';
import Ani8 from '../assets/images/icons/Animation/Ani8.svg';
import Ani9 from '../assets/images/icons/Animation/Ani9.svg';
import Ani10 from '../assets/images/icons/Animation/Ani10.svg';
import Ani11 from '../assets/images/icons/Animation/Ani11.svg';
import Ani12 from '../assets/images/icons/Animation/Ani12.svg';
import Ani13 from '../assets/images/icons/Animation/Ani13.svg';
import Ani14 from '../assets/images/icons/Animation/Ani14.svg';
import Ani15 from '../assets/images/icons/Animation/Ani15.svg';
import Ani16 from '../assets/images/icons/Animation/Ani16.svg';
import Ani17 from '../assets/images/icons/Animation/Ani17.svg';
import ObjectRightIcon from '../assets/images/icons/ObjectRightIcon.svg';
import ObjectBottomIcon from '../assets/images/icons/ObjectBottomIcon.svg';
import animationOrbit from '../assets/images/icons/animationOrbit.svg';
import animationPulse from '../assets/images/icons/animationPulse.svg';
import animationShake from '../assets/images/icons/animationShake.svg';
import animationWiggle from '../assets/images/icons/animationWiggle.svg';
import animationFadeIn from '../assets/images/icons/animationFadeIn.svg';
import animationFadeOut from '../assets/images/icons/animationFadeOut.svg';


import PreviewShare from '../assets/images/icons/Preview-Share.svg';


export const ObjectDraggingIcons = {
  ObjectRightIcon,
  ObjectBottomIcon,
};

export const animationIcons = {
  Ani1,
  Ani2,
  Ani3,
  Ani4,
  Ani5,
  Ani6,
  Ani7,
  Ani8,
  Ani9,
  Ani10,
  Ani11,
  Ani12,
  Ani13,
  Ani14,
  Ani15,
  Ani16,
  Ani17,
  animationOrbit,
  animationPulse,
  animationShake,
  animationWiggle,
  animationFadeIn,
  animationFadeOut,
};

//---------- Ar Vr Experience Icons -----------------//
import arVrDownArrow from '../assets/images/icons/arVrDownArrow.svg';
import arDropDown from '../assets/images/icons/arDrodown.svg';
import arIcon from '../assets/images/icons/aricon.svg';
import vrIcon from '../assets/images/icons/vricon.svg';
import xrIcon from '../assets/images/icons/xricon.svg';
import experienceSwitch from '../assets/images/icons/experience-Switch.svg';
import experienceChange from '../assets/images/icons/experience-change.svg';
import experienceLoad from '../assets/images/icons/experience-load.svg';
import experienceArrow from '../assets/images/icons/experienceArrow.svg';
import experiencDesktop from '../assets/images/icons/experience-desktop.svg';
import experiencGpu from '../assets/images/icons/experience-gpu.svg';
import experiencRam from '../assets/images/icons/experience-ram.svg';
import cameraTracking from '../assets/images/icons/cameraTracking.svg';
import sceneAnchor from '../assets/images/icons/sceneAnchor.svg';
import vrHeadset from '../assets/images/icons/vrHeadset.svg';
import lightControl from '../assets/images/icons/lightControl.svg';
import mrDesktop from '../assets/images/icons/mr-desktop.svg';
import mrMobile from '../assets/images/icons/mr-mobile.svg';
import mrLight from '../assets/images/icons/mr-light.svg';
import xrDepth from '../assets/images/icons/xr-depth.svg';
import xrInteraction from '../assets/images/icons/xr-interaction.svg';
import xrSurface from '../assets/images/icons/xr-surface.svg';
import xrTracking from '../assets/images/icons/xr-tracking.svg';
import xrDisplay from '../assets/images/icons/xr-display.svg';
import vrArHeadset from '../assets/images/icons/vr-ar-headset.svg';
import vrArLoad from '../assets/images/icons/vr-ar-load.svg';
import vrArCamera from '../assets/images/icons/vr-ar-camera.svg';
import vrXrSensors from '../assets/images/icons/vr-xr-sensors.svg';
import mrArLatestBrowser from '../assets/images/icons/mr-ar-latestBrowser.svg';
import mrVrPhysicalTrack from '../assets/images/icons/mr-vr-physicalTrack.svg';
import mrVrController from '../assets/images/icons/mr-vr-controllers.svg';
import mrVrHeadset from '../assets/images/icons/mr-vr-vrHeadset.svg';
import mrVrWebXr from '../assets/images/icons/mr-vr-webXr.svg';
import mrXrLayring from '../assets/images/icons/mr-xr-layring.svg';
import mrXrSpace from '../assets/images/icons/mr-xr-space.svg';
import xrVrView from '../assets/images/icons/xr-vr-view.svg';
import xrVrTracking from '../assets/images/icons/xr-vr-tracking.svg';
import xrVrVisuals from '../assets/images/icons/xr-vr-visuals.svg';
import xrVrGpu from '../assets/images/icons/xr-vr-gpu.svg';
import trackingMode from '../assets/images/icons/trackingMode.svg';
export const addcomponent = {
  group306,
  icon1,
  group366,
  group368,
  vectorfile,
};

//Image Target
import type1 from '../assets/images/icons/imagetarget/type1.svg';
import type2 from '../assets/images/icons/imagetarget/type2.svg';
import type3 from '../assets/images/icons/imagetarget/type3.svg';
import type4 from '../assets/images/icons/imagetarget/type4.svg';





export const imagetarget = {
  type1,
  type2,
  type3,
  type4,
};

//library icons
import libraryicon0 from '../assets/images/icons/library/libraryicon0.png';
import lbicon1 from '../assets/images/icons/library/lbicon1.png';
import lbicon2 from '../assets/images/icons/library/lbicon2.png';
import lbicon3 from '../assets/images/icons/library/lbicon3.png';
import lbicon4 from '../assets/images/icons/library/lbicon4.png';
import lbicon5 from '../assets/images/icons/library/lbicon5.png';
import lbicon6 from '../assets/images/icons/library/lbicon6.png';
import lbicon7 from '../assets/images/icons/library/lbicon7.png';
import lbicon8 from '../assets/images/icons/library/lbicon8.png';
import lbicon9 from '../assets/images/icons/library/lbicon9.png';

import container from '../assets/images/icons/library/container.svg';


export const libraryIcons = {
  libraryicon0,
  lbicon1,
  lbicon2,
  lbicon3,
  lbicon4,
  lbicon5,
  lbicon6,
  lbicon7,
  lbicon8,
  lbicon9,
  container,
};

export const analytics = {
  analytics1,
  // analytics2,
  analytics3,
  analytics4,
  analytics5,
  analytics6,
  analytics7,
  Group428,
  Group446,
  Group447,
  Group450,
  Vector7,
  Group275,
  Group444,
};


// Overall Analytics Icons 
import  view from '../assets/images/icons/AnalyticsNew/view.svg';      
import  folder from '../assets/images/icons/AnalyticsNew/folder.svg';
import  clock from '../assets/images/icons/AnalyticsNew/clock.svg';
import  click from '../assets/images/icons/AnalyticsNew/click.svg';
import  click1 from '../assets/images/icons/AnalyticsNew/click1.svg';     
import bounce from '../assets/images/icons/AnalyticsNew/bounce.svg';
import intensity1 from '../assets/images/icons/AnalyticsNew/intensity1.svg';
import intensity2 from '../assets/images/icons/AnalyticsNew/intensity2.svg';


export const OverallAnalytics = {
  view,
  folder,   
  clock,
  click,
  click1,
  bounce,
  intensity1,
  intensity2,
  
};

export const UserEngagementAnalytics = {
  Group468,
  Group467,
  Group498,
  Vector1,
  Vector2,
  Vector,
  India,
  Brazil,
  Japan,
  Southafrica,
  Southkorea,
  Unitedarabemirates,
  Unitedkingdom1,
  Unitedkingdom,
  Unitedstates,
  Group749,
};

export const imagePath = {
  com10,
  group101Image,
  group102Image,
  group103Image,
  group104Image,
  group105Image,
  group170Image,
  group41Image,
  Line9Image,
  layer2Image,
  helpImage,
  instagram,
  youtube,
  linkdin,
  discord,
  x,
  logo_small,
  card,
  logo,
  visual_editor,
  XR,
  logoImage,
  SearchIcon,
  group96Image,
  HelpCenterLevelIII,
  HelpCenterLevelIII_2,
  cursorImg,
  medhaLogo,
  qrCodeImage,
  gridImage,
  areaTracking,
  bodyTracking,
  faceTracking,
  imageTracking,
  locationTracking,
  surfaceTracking,
  worldTracking,
  waterParticleTexture,
  handTracking,
  torsoTracking,
  footTracking,
  wristTracking,
  // padImg,
};

export const iconsPath = {
  group131Image,
  vector2Image,
  group34Image,
  group24Image,
  group252Image,
  group25Image,
  group26Image,
  menuIcon,
  group9Image,
  group7Image,
  group8Image,
  group4Image,
  line4Image,
  line5Image,
  line7Image,
  vector6Image,

  group141Image,
  vector3Image,
  vectorImage,
  vector4Image,
  Unlockvector5Image,
  group290Image,
  line1Image,
  line2Image,
  line3Image,
  questionImage,

  group32Image,
  group33Image,
  group35Image,

  group10Image,
  group13Image,
  group16Image,
  group14Image,
  group15Image,
  group20Image,
  vector5Image,
  line6Image,
  group562Image,
  group563Image,
  group564Image,
  group566Image,
  group567Image,
  group569Image,
  group570Image,

  group571Image,
  group572Image,
  Vector44Image,
  Vector45Image,
  group98Image,
  filterImage,

  vector8Image,
  vector9Image,
  vector10Image,
  group72Image,
  group73Image,
  group74Image,

  group39Image,
  LibraryImage,
  group40Image,
  group42Image,
  backarrowImage,
  group598Image,

  Layer1Image,
  Layer2Image,
  Layer3Image,
  Layer4Image,
  Layer5Image,
  Layer6Image,
  Layer7Image,
  Layer8Image,
  Layer9Image,
  Layer10Image,
  Layer11Image,
  Layer12Image,

  Layer13Image,
  Element1Image,
  Element2Image,
  Element3Image,
  Element4Image,
  Element5Image,
  Element6Image,
  Element7Image,

  Light1Image,
  Light2Image,
  Light3Image,

  Help1Image,
  Help2Image,
  Help3Image,
  Help4Image,
  group112Image,

  group95Image,
  Emoji1Image,
  Emoji2Image,
  Emoji3Image,
  Emoji4Image,
  Emoji5Image,

  group117Image,
  group595Image,
  threeDots,

  PlayIcon,
  QRIcon,
  group406Image,
  group750Image,
  group388Image,
  logoutIcon,

  // New Icons by Naveen
  plusIcon,
  minusIcon,
  rightArrowRed,
  googleIcon,
  leftIcon,
  downIcon,
  rightIcon,
  closeIcon,
  folderIcon,
  eyeIcon,
  perspective,
  orthographic,
  spatialgridLogo,

  // new Text module icons
  horizontolLeft,
  horizontolCenter,
  horizontolRight,
  verticalTop,
  verticalCenter,
  verticalBottom,
  AudioIcon,
  text,

  uploadIcon,
  uploadIcon2,
  replayIcon,
  mcpSpeaker,
  mcpTool,
  mcpArrow,
  mcpScrollView,
  newChat,
  mcpHistoryOpen,
  mcpHistoryClose,
  historyDeleteWarning,
  copy_link,
  share_vie_email,
  embaded_code,
  searchImage,
  invite_collaborators,
  verticalThreeDots,
  arVrDownArrow,
  arDropDown,
  arIcon,
  vrIcon,
  xrIcon,
  experienceSwitch,
  experienceChange,
  experienceLoad,
  experienceArrow,
  cameraTracking,
  sceneAnchor,
  vrHeadset,
  lightControl,
  experiencDesktop,
  experiencGpu,
  experiencRam,
  mrDesktop,
  mrMobile,
  mrLight,
  xrDepth,
  xrInteraction,
  xrSurface,
  xrTracking,
  xrDisplay,
  vrArHeadset,
  vrArLoad,
  vrArCamera,
  vrXrSensors,
  mrArLatestBrowser,
  mrVrPhysicalTrack,
  mrVrController,
  mrVrHeadset,
  mrVrWebXr,
  mrXrLayring,
  mrXrSpace,
  xrVrView,
  xrVrTracking,
  xrVrVisuals,
  xrVrGpu,
  trackingMode,
  playParticale,
  pausePartical,
  Light4,
  projectFilter1,
  projectFilter2,
  ambientlight,
  arealight,
  vpsZip,
  gaussianSplat,
  PreviewShare,
  libraryIcons: {
    libraryicon0,
    lbicon1,
    lbicon2,
    lbicon3,
    lbicon4,
    lbicon5,
    lbicon6,
    lbicon7,
    lbicon8,
    lbicon9,
    container,
  },
};
